export Tetris from "./tetris/Tetris";
export Sokoban from "./sokoban/Sokoban";
export Mines from "./mines/Mines";
export Pexeso from "./pexeso/Pexeso";
